module.exports = __webpack_public_path__ + "img/top-praise@3x.e2facfb2.png";